import { Loader2 } from "lucide-react";

const fmtTimeLabel = (hhmm) => {
  const [h, m] = hhmm.split(":").map((n) => parseInt(n, 10));
  const period = h >= 12 ? "PM" : "AM";
  const hh = ((h + 11) % 12) + 1;
  return `${hh}:${String(m).padStart(2, "0")} ${period}`;
};

/**
 * Right-hand pane of Step 2 — renders loading / error / slots / empty state
 * for the chosen date. Extracted so Step2DateTime stays focused on calendar
 * + state coordination.
 */
export default function SlotsView({ loading, error, slots, info, selectedDate, selectedTime, onSelectTime }) {
  if (loading) {
    return (
      <div className="flex items-center gap-2 text-sm py-4" data-testid="slots-loading">
        <Loader2 className="w-4 h-4 animate-spin" style={{ color: "var(--pp-indigo)" }} />
        <span style={{ color: "var(--pp-muted)" }}>Loading…</span>
      </div>
    );
  }
  if (error) {
    return (
      <p className="text-sm" style={{ color: "var(--pp-error)" }} data-testid="slots-error">
        {error}
      </p>
    );
  }
  if (selectedDate && slots.length > 0) {
    return (
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-3 gap-2" data-testid="slots-grid">
        {slots.map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => onSelectTime(t)}
            className={`pp-time-slot text-xs sm:text-sm ${selectedTime === t ? "selected" : ""}`}
            data-testid={`time-slot-${t}`}
          >
            {fmtTimeLabel(t)}
          </button>
        ))}
      </div>
    );
  }
  if (selectedDate) {
    return (
      <p className="text-sm" style={{ color: "var(--pp-muted)" }} data-testid="slots-empty">
        {info || "No available slots."}
      </p>
    );
  }
  return (
    <p className="text-xs" style={{ color: "var(--pp-muted)" }}>
      Pick a day to see available times.
    </p>
  );
}
